export enum OrganPackaging {
    InHouse = 1,
    Opo = 2
}

export interface IOpoCenterPackaging {
    centerId: number,
    livingDonorPackaging: OrganPackaging | null,
    deceasedDonorPackaging: OrganPackaging | null,
    needsGpsServices: boolean | null,
    isSuggested: boolean
}

export interface IOpoPackagingCenter {
    id: number,
    alias: string,
    name: string,
    unosId: string,
    centerProfilePackaging: OrganPackaging | null,
    centerProfileUsesThisOpo: boolean
}

export interface IOpoPackagingData {
    rows: IOpoCenterPackaging[],
    centers: IOpoPackagingCenter[],
    canManage: boolean
}

export interface IOpoPackagingRequest {
    centers: {
        centerId: number,
        livingDonorPackaging: OrganPackaging,
        deceasedDonorPackaging: OrganPackaging,
        needsGpsServices: boolean
    }[]
}
